import type { ReactNode } from 'react'

/**
 * The measure for a portal screen, in one place (D-380).
 *
 * **Why this is a component rather than a class string copied twice.** Both
 * portals used to carry `portal-shell` themselves. Home renders both, so nested
 * inside its own shell they doubled the padding the utility already sets —
 * measured at 820px as three different left edges, 94, 111 and 118, with each
 * heading floating 24px from the thing it heads. Removing theirs fixed Home and
 * broke `/me` and `/teacher`, which have no other container: the portal drew at
 * the full width of the content area, reported from real use.
 *
 * The measure therefore belongs to whoever is laying out — the same rule D-358
 * settled for margins — and there are exactly two layouts that need it: Home,
 * which wraps three blocks, and the two standalone routes, which wrap one. Two
 * copies of one idea drift and the second never receives the first's fixes, so
 * they share this rather than both spelling it out.
 *
 * **`pb-24` is thumb clearance, not taste.** The bottom bar is fixed and 54px
 * tall where `portal-shell` gives 24, so without it the last card sits under the
 * bar on a handset. Off from `sm` up, where there is no bar.
 */
export default function PortalShell({ children }: { children: ReactNode }) {
  return <div className="portal-shell pb-24 sm:pb-0">{children}</div>
}
